<template>
  <pro-list-frame
    ref="plTable"
    :title="(titleProp
          ? $t(titleProp)
          : $route.name == 'ProductList'
          ? $t('productList')
          : $route.name == 'VariantsList' || $route.name == 'Variants'
          ? $t('variant-product')
          : $t('serviceList'))"
    icon="mdi-package-variant-closed"
    :total="totalItems"
    :rows="items.length"
    :search.sync="search"
    :columns="toggleableHeaders"
    :hidden="hiddenColumns"
    :selected-count="selected.length"
    :loading="loading"
    :cell-sel="cellSel"
    :fixed="!mobileShow"
    :create-label="(!mobileShow &&
          $route.name !== 'VariantsList' &&
          $route.name !== 'Variants') ? $t($route.name == 'ProductList' ? 'newProduct' : 'newService') : ''"
    @refresh="getItems"
    @filter="filter = true"
    @print="printStudio = true"
    @create="goTo($route.name == 'ProductList' ? 'Product' : 'Service')"
    @toggle-column="toggleColumn"
    @show-all-columns="hiddenColumns = []"
    @cell-down="onCellDown"
    @cell-over="onCellOver"
    @clear-cells="clearCellSel"
    @clear-selection="selected = []"
  >
    <template #tools>
      <export-excel
        ref="refExcel"
        :data="excelItems"
        worksheet="abriron.com"
        name="data.xls"
        type="xls"
        :title="$store.state.abrName"
        :total-prop="pageCount"
        :page-prop="excelPage"
        @getAllRows="getAllRows"
      >
        <button type="button" class="pl-btn pl-btn--icon" :title="$t('excel')">
          <v-icon size="16" color="#2E7D32">mdi-file-excel-outline</v-icon>
        </button>
      </export-excel>
      <v-menu offset-y left>
        <template v-slot:activator="{ attrs, on }">
          <button type="button" class="pl-btn pl-btn--icon" v-bind="attrs" v-on="on">
            <v-icon size="16">mdi-dots-vertical</v-icon>
          </button>
        </template>
        <v-list dense>
          <v-list-item link @click="openUploadDialog('data')">
            <v-list-item-icon>
              <v-icon>mdi-database-import-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('importData')" />
          </v-list-item>
          <v-list-item link @click="openUploadDialog('integrator')">
            <v-list-item-icon>
              <!-- <v-icon>mdi-database-import-outline</v-icon> -->
              <v-icon>mdi-file-import-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('import-integrator-info')" />
          </v-list-item>
          <!-- export integrator data with excel -->
          <v-list-item link @click="openExcelDialog()">
            <v-list-item-icon>
              <v-icon>mdi-file-export-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('export-integrator-info')" />
          </v-list-item>
          <v-list-item link @click="excelUpdatePrice">
            <v-list-item-icon>
              <v-icon>mdi-currency-usd</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('excelUpdatePrice')" />
          </v-list-item>
          <v-list-item v-if="selected.length > 0" link @click="rebuildGoodCost">
            <v-list-item-icon>
              <v-icon>mdi-wrench-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('rebuildGoodCost')" />
          </v-list-item>
          <v-list-item link @click="barcode">
            <v-list-item-icon>
              <v-icon>mdi-barcode</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('productBarcode')" />
          </v-list-item>
          <!--add update product-->
          <v-list-item v-if="selected.length > 0" link @click="upateProdyctInventory">
            <v-list-item-icon>
              <v-icon>mdi-autorenew</v-icon>
            </v-list-item-icon>
            <v-list-item-title
              v-text="$t('Updating Product Inventory in the Integrator')"
            />
          </v-list-item>
          <!-- -->
          <log
            v-if="
              $store.state.permissions && $store.state.permissions.includes('logList')
            "
            ref="logRef"
            :type-prop="typeForm"
            :listProp="true"
            mode-prop="button"
          />
          
          
          
          
        </v-list>
      </v-menu>
    </template>
    <template #bulk>
      <button
        v-if="removePermission(typeForm) && !mobileShow"
        type="button"
        class="pl-bulk__btn pl-bulk__btn--danger"
        @click="deletDialog = true"
      >
        <v-icon size="17">mdi-trash-can-outline</v-icon>
        {{ $t("remove") }}
      </button>
    </template>
      <v-data-table
        v-if="headers"
        ref="listTable"
        v-column-resize="productListColumnPlugins"
        v-column-drag="productListColumnPlugins"
        v-column-pin="productListColumnPlugins"
        v-model="selected"
        :height="mobileShow ? 323 : plTableH"
        fixed-header
        :headers="tableHeaders"
        :items="items"
        :options.sync="tableOptions"
        :server-items-length="totalItems"
        :loading="false"
        :page.sync="page"
        :hide-default-header="isMobile || mobileShow"
        multi-sort
        :show-select="showSelect"
        item-key="id"
        :footer-props="plFooterProps"
      >
        <template v-if="isMobile || mobileShow" v-slot:item="{ item, index }">
          <tr :class="{ 'mobile-show': mobileShow }">
            <td class="px-0">
              <v-list-item
                class="data-table-list-items mobile-td-list-border-primary"
                dense
              >
                <v-list-item-icon>
                  <div class="d-flex">
                    <p class="mt-1">
                      {{ +index + +1 }}
                    </p>
                    <v-menu offset-y>
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn color="primary" v-bind="attrs" icon v-on="on">
                          <v-icon medium> mdi-dots-vertical </v-icon>
                        </v-btn>
                      </template>
                      <v-list dense>
                        <v-list-item link @click="edit(item)">
                          <v-list-item-icon>
                            <v-icon class="mt-2"> mdi-clipboard-edit </v-icon>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-bind="attrs"
                                  icon
                                  small
                                  v-on="on"
                                  @click.stop.prevent="newTab('ProductEdit', item)"
                                >
                                  <v-icon small color="primary">
                                    mdi-content-duplicate
                                  </v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t("newTab") }}</span>
                            </v-tooltip>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('edit')" />
                        </v-list-item>
                        <v-list-item link @click="turnover(item, null)">
                          <v-list-item-icon>
                            <v-icon>mdi-recycle-variant</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('productTurnover')" />
                        </v-list-item>
                        <v-list-item link @click="turnoverCount(item, null)">
                          <v-list-item-icon>
                            <v-icon>mdi-ballot-recount-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('productCountTurnover')" />
                        </v-list-item>
                        <v-list-item link @click="turnoverAmount(item, null)">
                          <v-list-item-icon>
                            <v-icon>mdi-chart-gantt</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('productAmountTurnover')" />
                        </v-list-item>
                        <v-list-item link @click="openProductCard(item)">
                          <v-list-item-icon>
                            <v-icon>mdi-card-bulleted-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('productCard')" />
                        </v-list-item>
                        <v-list-item
                          v-clipboard:copy="
                            $baseURL +
                            '/' +
                            (typeForm == 'product' ? 'product' : 'service') +
                            '/edit/' +
                            item.id
                          "
                          link
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-link</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('copy-link')" />
                        </v-list-item>
                        <log
                          :title-prop="$t('history')"
                          icon-prop="mdi-history"
                          :listProp="true"
                          :type-prop="typeForm"
                          :refIdProp="item.id"
                          mode-prop="button"
                        />
                        <v-list-item
                          v-show="removePermission(typeForm)"
                          link
                          @click="openDeleteDialog(item)"
                        >
                          <v-list-item-icon>
                            <v-icon color="pink"> mdi-trash-can-outline </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('remove')" />
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="text-wrap">
                    {{ item.name }}({{ item.code }})
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-wrap">
                    {{ $t("unit") }} : {{ item.unit ? item.unit.fame : "" }} |
                    {{ $t("price") }} : {{ $numberFormat(parseFloat(item.price)) }}
                    {{ $store.state.currencySymbol }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    <div class="pt-1">
                      <v-chip
                        v-for="(tag, index) in item.tags"
                        :key="index"
                        :color="tag.color"
                        label
                        small
                        style="margin-left: 1px; margin-right: 1px"
                        class="px-1 mb-1"
                      >
                        <span class="px-1 white--text">
                          {{ tag.text }}
                        </span>
                      </v-chip>
                    </div>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn dark text small color="primary" @click="entrepotTurnover(item)">
                    {{ $t("stock") }}:{{ item.stock ? item.stock.count : "" }}
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </td>
          </tr>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="pl-action-cell">
            <v-menu offset-y :z-index="100">
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  color="primary"
                  class="pl-action-cell__btn"
                  v-bind="attrs"
                  icon
                  x-small
                  v-on="on"
                >
                  <v-icon small> mdi-dots-vertical </v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item link @click="edit(item)">
                  <v-list-item-icon>
                    <v-icon class="mt-2"> mdi-clipboard-edit </v-icon>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          icon
                          small
                          v-on="on"
                          @click.stop.prevent="newTab('ProductEdit', item)"
                        >
                          <v-icon small color="primary"> mdi-content-duplicate </v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("newTab") }}</span>
                    </v-tooltip>
                  </v-list-item-icon>
                  <v-list-item-title v-text="$t('edit')" />
                </v-list-item>
                <v-list-item link @click="turnover(item, null)">
                  <v-list-item-icon>
                    <v-icon>mdi-recycle-variant</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title v-text="$t('productTurnover')" />
                </v-list-item>
                <v-list-item link @click="turnoverCount(item, null)">
                  <v-list-item-icon>
                    <v-icon>mdi-ballot-recount-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title v-text="$t('productCountTurnover')" />
                </v-list-item>
                <v-list-item link @click="barcodeSingle(item)">
                  <v-list-item-icon>
                    <v-icon>mdi-barcode</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title v-text="$t('barcode')" />
                </v-list-item>
                <v-list-item link @click="turnoverAmount(item, null)">
                  <v-list-item-icon>
                    <v-icon>mdi-chart-gantt</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title v-text="$t('productAmountTurnover')" />
                </v-list-item>
                <v-list-item
                  v-if="
                    $store.state.permissions &&
                    $store.state.permissions.includes('productCard')
                  "
                  link
                  @click="openProductCard(item)"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-card-bulleted-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title v-text="$t('productCard')" />
                </v-list-item>
                <v-list-item
                  v-if="
                    $store.state.permissions &&
                    $store.state.permissions.includes('rebuildGoodCost')
                  "
                  link
                  @click="rebuildGoodCostItem(item)"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-wrench-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title v-text="$t('rebuildGoodCost')" />
                </v-list-item>
                <v-list-item
                  v-clipboard:copy="
                    $baseURL +
                    '/' +
                    (typeForm == 'product' ? 'product' : 'service') +
                    '/edit/' +
                    item.id
                  "
                  link
                >
                  <v-list-item-icon>
                    <v-icon>mdi-link</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title v-text="$t('copy-link')" />
                </v-list-item>
                <log
                  :title-prop="$t('history')"
                  icon-prop="mdi-history"
                  :listProp="true"
                  :type-prop="typeForm"
                  :refIdProp="item.id"
                  mode-prop="button"
                />
                <v-list-item
                  v-show="removePermission(typeForm)"
                  link
                  @click="openDeleteDialog(item)"
                >
                  <v-list-item-icon>
                    <v-icon color="pink"> mdi-trash-can-outline </v-icon>
                  </v-list-item-icon>
                  <v-list-item-title v-text="$t('remove')" />
                </v-list-item>
              </v-list>
            </v-menu>
            <span class="pl-action-cell__row">{{
              parseInt(items.indexOf(item)) + parseInt(from)
            }}</span>
          </div>
        </template>
        <template v-slot:item.name="{ item }">
          <div class="d-flex align-center gap-2">
            <div>
              <v-avatar
                tile
                width="35"
                height="35"
                class="my-2"
                style="border-radius: 5px !important"
              >
                <img
                  :src="item && item.avatar ? item.avatar.link : '/img/noImage.png'"
                  :alt="item.name"
                />
              </v-avatar>
            </div>
            <div>
              <div class="d-flex">
                <p class="mb-0" style="color: rgb(145 145 145)">{{ item.id }} #</p>
                <a @click="edit(item)" class="text-body-2">{{ item.name }}</a>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-if="item.bundle"
                      v-bind="attrs"
                      color="teal"
                      icon
                      x-small
                      v-on="on"
                    >
                      <v-icon>mdi-package-variant-closed</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("isBundle") }}</span>
                </v-tooltip>
              </div>
              <div style="color: rgb(164, 164, 164); font-size: 10px">
                {{ item.group ? item.group.name : "" }}
                {{ item.cat1 ? "," + item.cat1.name : "" }}
                {{ item.cat2 ? "," + item.cat2.name : "" }}
                {{ !item.group && !item.cat1 && !item.cat2 ? $t("withoutCategory") : "" }}
              </div>
            </div>
          </div>
        </template>
        <template v-slot:item.code="{ item }">
          <v-card-text class="pa-0 text-caption text-disable secondary--text">
            {{ item.code ? item.code : $t("haveNot") }}
          </v-card-text>
        </template>
        <template v-slot:item.meta.priority="{ item }">
          <v-card-text class="pa-0 text-caption text-disable secondary--text">
            {{
              item.meta && item.meta.priority != null ? item.meta.priority : $t("haveNot")
            }}
          </v-card-text>
        </template>
        <template v-slot:item.kind_id="{ item }">
          {{ item.kind ? item.kind.name : $t("product") }}
        </template>
        <template v-slot:item.stock="{ item }">
          <v-btn
            v-if="!item.bundle"
            class="mx-2"
            dark
            text
            small
            style="padding: 12px 4px !important; justify-content: start"
            color="primary"
            @click="entrepotTurnover(item)"
          >
            {{ item.stock ? item.stock.count : 0 }}
          </v-btn>
          <v-btn
            v-if="item.bundle"
            class="mx-2"
            dark
            text
            small
            style="padding: 12px 4px !important; justify-content: start"
            color="primary"
          >
            {{ item.stockBundle ? item.stockBundle.count : 0 }}
          </v-btn>
        </template>
        <!--variant clickble-->
        <template v-slot:item.variants_count="{ item }">
          <v-btn
            class="mx-2"
            dark
            text
            small
            style="padding: 12px 4px !important; justify-content: start"
            color="primary"
            @click="goToVariants(item)"
          >
            {{ item.variants_count || 0 }}
          </v-btn>
        </template>
        <template v-slot:item.order_point="{ item }">
          <v-card-text class="pa-0 text-caption text-disable secondary--text">
            {{ item.order_point ?? $t("haveNot") }}
          </v-card-text>
        </template>
        <template v-slot:item.barcode="{ item }">
          <v-card-text class="pa-0 text-caption text-disable secondary--text">
            {{ item.barcode ?? $t("haveNot") }}
          </v-card-text>
        </template>
        <template v-slot:item.price="{ item }">
          <a @click="edit(item)">
            {{ $numberFormat(parseFloat(item.price)) }} {{ $store.state.currencySymbol }}
          </a>
        </template>
        <template v-slot:item.content="{ item }">
          <v-card-text
            v-if="
              item.integrator.length == 0 ||
              (item.integrator.length != 0 &&
                item.integrator.markitoId == null &&
                item.integrator.portalId == null &&
                item.integrator.portalVariantId == null &&
                item.integrator.webziId == null &&
                item.integrator.webziVariantId == null &&
                item.integrator.woocommerceId == null &&
                item.integrator.woocommerceVariantId == null &&
                item.integrator.basalamId == null &&
                item.integrator.basalamVariantId == null &&
                item.digikala_product != undefined &&
                item.digikala_product.length == 0 &&
                item.basalamIntegrator != undefined &&
                item.basalamIntegrator.length == 0 &&
                item.sazito_product != undefined &&
                item.sazito_product.length == 0 &&
                item.mixin_product != undefined &&
                item.mixin_product.length == 0 &&
                item.snapshop_product != undefined &&
                item.snapshop_product.length == 0 &&
                item.content == null &&
                item.custom_fields.length == 0)
            "
            class="pa-0 text-caption text-disable secondary--text"
          >
            {{ $t("haveNot") }}
          </v-card-text>
          <template v-if="item.woocommerceItems && item.woocommerceItems.length > 0">
            <template v-for="(wooItem, wooIndex) in item.woocommerceItems">
              <!--woocommerce id-->
              <v-container
                v-if="wooItem.woocommerceId"
                :key="'woo-id-' + wooIndex"
                class="pa-0 d-flex align-center gap-1"
              >
                <img src="@/assets/woo.png" style="width: 20px; border-radius: 0" />
                <v-card-text class="pa-0 text-caption">{{ $t("id") }}: </v-card-text>
                <v-card-text
                  v-clipboard:copy="wooItem.woocommerceId"
                  @click="copied"
                  class="pa-0 text-caption text-disable secondary--text"
                  style="cursor: pointer"
                >
                  {{ wooItem.woocommerceId }}
                </v-card-text>
              </v-container>
              <!--woocommerce variant-->
              <v-container
                v-if="wooItem.woocommerceVariantId"
                :key="'woo-variant-' + wooIndex"
                class="pa-0 d-flex align-center gap-1"
              >
                <img src="@/assets/woo.png" style="width: 20px; border-radius: 0" />
                <v-card-text class="pa-0 text-caption"
                  >{{ $t("variable") }}:
                </v-card-text>
                <v-card-text
                  v-clipboard:copy="wooItem.woocommerceVariantId"
                  @click="copied"
                  class="pa-0 text-caption text-disable secondary--text"
                  style="cursor: pointer"
                >
                  {{ wooItem.woocommerceVariantId }}
                </v-card-text>
              </v-container>
            </template>
          </template>
          <!--markito id-->
          <v-container
            class="pa-0 d-flex align-center gap-1"
            v-if="item.integrator != null && item.integrator.markitoId != null"
          >
            <img src="@/assets/markitoLogo.png" style="width: 20px; border-radius: 0" />
            <v-card-text class="pa-0 text-caption">{{ $t("id") }}: </v-card-text>
            <v-card-text
              v-if="item.integrator != null && item.integrator.markitoId != null"
              v-clipboard:copy="item.integrator.markitoId"
              @click="copied"
              class="pa-0 text-caption text-disable secondary--text"
              style="cursor: pointer"
            >
              {{ item.integrator.markitoId }}
            </v-card-text>
          </v-container>
          <!-- portal v3 -->
          <v-container
            class="pa-0"
            v-if="item.portal_product != undefined && item.portal_product.length > 0"
          >
            <div v-for="(obj, index) in item.portal_product" :key="index">
              <div class="d-flex align-center">
                <img
                  src="@/assets/portal_no_bg.png"
                  style="width: 20px; border-radius: 0"
                />
                <v-card-text class="pa-0 text-caption">{{ $t("id") }}:</v-card-text>
                <v-card-text
                  v-clipboard:copy="obj.portal_id"
                  @click="copied"
                  class="pa-0 text-caption"
                >
                  {{ obj.portal_id }}
                </v-card-text>
              </div>
              <div class="d-flex align-center">
                <img
                  src="@/assets/portal_no_bg.png"
                  style="width: 20px; border-radius: 0"
                />
                <v-card-text class="pa-0 text-caption"
                  >{{ $t("portalVariantId") }}:</v-card-text
                >
                <v-card-text
                  v-clipboard:copy="obj.portal_variant_id"
                  @click="copied"
                  class="pa-0 text-caption"
                >
                  {{ obj.portal_variant_id }}
                </v-card-text>
              </div>
            </div>
          </v-container>
          <!--sazito (new)-->
          <v-container
            class="pa-0"
            v-if="item.sazito_product != undefined && item.sazito_product.length > 0"
          >
            <div v-for="(obj, index) in item.sazito_product" :key="index">
              <div class="d-flex align-center">
                <img src="@/assets/sazito.png" style="width: 20px; border-radius: 0" />
                <v-card-text class="pa-0 text-caption">{{ $t("sazitoId") }}</v-card-text>
                <v-card-text class="pa-0 text-caption"
                  >({{ obj.panels != null ? obj.panels.name : "-" }}) :</v-card-text
                >
                <v-card-text
                  v-clipboard:copy="obj.sazito_id"
                  @click="copied"
                  class="pa-0 text-caption"
                >
                  {{ obj.sazito_id }}
                </v-card-text>
              </div>
              <div class="d-flex align-center">
                <img src="@/assets/sazito.png" style="width: 20px; border-radius: 0" />
                <v-card-text class="pa-0 text-caption">{{
                  $t("sazitoVariantId")
                }}</v-card-text>
                <v-card-text class="pa-0 text-caption"
                  >({{ obj.panels != null ? obj.panels.name : "-" }}) :</v-card-text
                >
                <v-card-text
                  v-clipboard:copy="obj.sazito_dynamic_id"
                  @click="copied"
                  class="pa-0 text-caption"
                >
                  {{ obj.sazito_dynamic_id }}
                </v-card-text>
              </div>
            </div>
          </v-container>
          <!--mixin (new)-->
          <v-container
            class="pa-0"
            v-if="item.mixin_product != undefined && item.mixin_product.length > 0"
          >
            <div v-for="(obj, index) in item.mixin_product" :key="index">
              <div class="d-flex align-center">
                <img
                  src="@/assets/integrators/mixin.png"
                  style="width: 20px; border-radius: 0"
                />
                <v-card-text class="pa-0 text-caption">{{ $t("mixinId") }}</v-card-text>
                <v-card-text class="pa-0 text-caption"
                  >({{ obj.panels != null ? obj.panels.name : "-" }}) :</v-card-text
                >
                <v-card-text
                  v-clipboard:copy="obj.mixin_id"
                  @click="copied"
                  class="pa-0 text-caption"
                >
                  {{ obj.mixin_id }}
                </v-card-text>
              </div>
              <div v-if="obj.mixin_variant_id != null" class="d-flex align-center">
                <img
                  src="@/assets/integrators/mixin.png"
                  style="width: 20px; border-radius: 0"
                />
                <v-card-text class="pa-0 text-caption">{{
                  $t("mixinVariantId")
                }}</v-card-text>
                <v-card-text class="pa-0 text-caption"
                  >({{ obj.panels != null ? obj.panels.name : "-" }}) :</v-card-text
                >
                <v-card-text
                  v-clipboard:copy="obj.mixin_variant_id"
                  @click="copied"
                  class="pa-0 text-caption"
                >
                  {{ obj.mixin_variant_id }}
                </v-card-text>
              </div>
            </div>
          </v-container>
          <!--snapshop (new)-->
          <v-container
            class="pa-0"
            v-if="item.snapshop_product != undefined && item.snapshop_product.length > 0"
          >
            <div v-for="(obj, index) in item.snapshop_product" :key="index">
              <div class="d-flex align-center">
                <img
                  src="@/assets/integrators/snapShop.png"
                  style="width: 20px; border-radius: 0"
                />
                <v-card-text class="pa-0 text-caption">{{
                  $t("snapshopId")
                }}</v-card-text>
                <v-card-text class="pa-0 text-caption"
                  >({{ obj.panels != null ? obj.panels.name : "-" }}) :</v-card-text
                >
                <v-card-text
                  v-clipboard:copy="obj.snapshop_id"
                  @click="copied"
                  class="pa-0 text-caption"
                >
                  {{ obj.snapshop_id }}
                </v-card-text>
              </div>
              <div class="d-flex align-center">
                <img
                  src="@/assets/integrators/snapShop.png"
                  style="width: 20px; border-radius: 0"
                />
                <v-card-text class="pa-0 text-caption">{{
                  $t("snapshopVariantId")
                }}</v-card-text>
                <v-card-text class="pa-0 text-caption"
                  >({{ obj.panels != null ? obj.panels.name : "-" }}) :</v-card-text
                >
                <v-card-text
                  v-clipboard:copy="obj.snapshop_variant_id"
                  @click="copied"
                  class="pa-0 text-caption"
                >
                  {{ obj.snapshop_variant_id }}
                </v-card-text>
              </div>
            </div>
          </v-container>
          <!--sazito (old)-->
          <!--sazito id-->
          <!-- <v-container class="pa-0 d-flex align-center gap-1" v-if="item.integrator != null && item.integrator.sazitoId != null">
            <img src="@/assets/sazito.png" style="width: 20px;border-radius: 0;" />
            <v-card-text class="pa-0 text-caption">{{ $t('id') }}: </v-card-text>
            <v-card-text
              v-if="item.integrator != null && item.integrator.sazitoId != null"
              v-clipboard:copy="item.integrator.sazitoId"
              @click="copied"
              class="pa-0 text-caption text-disable secondary--text"
              style="cursor: pointer;"
            >
            {{ item.integrator.sazitoId }}
            </v-card-text>
          </v-container> -->
          <!--sazito variant id-->
          <!-- <v-container class="pa-0 d-flex align-center gap-1" v-if="item.integrator != null && item.integrator.sazitoVariantId != null">
            <img src="@/assets/sazito.png" style="width: 20px;border-radius: 0;" />
            <v-card-text class="pa-0 text-caption">{{ $t('variable') }}: </v-card-text>
            <v-card-text
              v-if="item.integrator != null && item.integrator.sazitoVariantId != null"
              v-clipboard:copy="item.integrator.sazitoVariantId"
              @click="copied"
              class="pa-0 text-caption text-disable secondary--text"
              style="cursor: pointer;"
            >
            {{ item.integrator.sazitoVariantId }}
            </v-card-text>
          </v-container> -->
          <!--webzi id-->
          <v-container
            class="pa-0 d-flex align-center gap-1"
            v-if="item.integrator != null && item.integrator.webziId != null"
          >
            <img src="@/assets/webzi.png" style="width: 20px; border-radius: 0" />
            <v-card-text class="pa-0 text-caption">{{ $t("id") }}: </v-card-text>
            <v-card-text
              v-if="item.integrator != null && item.integrator.webziId != null"
              v-clipboard:copy="item.integrator.webziId"
              @click="copied"
              class="pa-0 text-caption text-disable secondary--text"
              style="cursor: pointer"
            >
              {{ item.integrator.webziId }}
            </v-card-text>
          </v-container>
          <!--webzi variant-->
          <v-container
            class="pa-0 d-flex align-center gap-1"
            v-if="item.integrator != null && item.integrator.webziVariantId != null"
          >
            <img src="@/assets/webzi.png" style="width: 20px; border-radius: 0" />
            <v-card-text class="pa-0 text-caption">{{ $t("variable") }}: </v-card-text>
            <v-card-text
              v-if="item.integrator != null && item.integrator.webziVariantId != null"
              v-clipboard:copy="item.integrator.webziVariantId"
              @click="copied"
              class="pa-0 text-caption text-disable secondary--text"
              style="cursor: pointer"
            >
              {{ item.integrator.webziVariantId }}
            </v-card-text>
          </v-container>
          <!--digikala (new)-->
          <v-container
            class="pa-0"
            v-if="item.digikala_product != undefined && item.digikala_product.length > 0"
          >
            <div v-for="(obj, index) in item.digikala_product" :key="index">
              <div class="d-flex align-center">
                <img src="@/assets/digikala.png" style="width: 20px; border-radius: 0" />
                <v-card-text class="pa-0 text-caption">DKP </v-card-text>
                <v-card-text class="pa-0 text-caption"
                  >({{ obj.panels != null ? obj.panels.name : "-" }}) :</v-card-text
                >
                <v-card-text
                  v-clipboard:copy="obj.digikala_product_id"
                  @click="copied"
                  class="pa-0 text-caption"
                >
                  {{ obj.digikala_product_id }}
                </v-card-text>
              </div>
              <div class="d-flex align-center">
                <img src="@/assets/digikala.png" style="width: 20px; border-radius: 0" />
                <v-card-text class="pa-0 text-caption">DKPC </v-card-text>
                <v-card-text class="pa-0 text-caption"
                  >({{ obj.panels != null ? obj.panels.name : "-" }}) :</v-card-text
                >
                <v-card-text
                  v-clipboard:copy="obj.product_variant_id"
                  @click="copied"
                  class="pa-0 text-caption"
                >
                  {{ obj.product_variant_id }}
                </v-card-text>
              </div>
            </div>
          </v-container>
          <!--basalam (new)-->
          <v-container
            class="pa-0"
            v-if="
              item.basalamIntegrator != undefined && item.basalamIntegrator.length > 0
            "
          >
            <div v-for="(obj, index) in item.basalamIntegrator" :key="index">
              <div class="d-flex align-center">
                <img src="@/assets/basalam.png" style="width: 20px; border-radius: 0" />
                <v-card-text class="pa-0 text-caption">{{ $t("id") }}</v-card-text>
                <v-card-text class="pa-0 text-caption"
                  >({{ obj.basalamPanelName != null ? obj.basalamPanelName.name : "-" }})
                  :</v-card-text
                >
                <v-card-text
                  v-clipboard:copy="obj.basalamId"
                  @click="copied"
                  class="pa-0 text-caption"
                >
                  {{ obj.basalamId }}
                </v-card-text>
              </div>
              <div class="d-flex align-center">
                <img src="@/assets/basalam.png" style="width: 20px; border-radius: 0" />
                <v-card-text class="pa-0 text-caption">{{ $t("variantId") }}</v-card-text>
                <v-card-text class="pa-0 text-caption"
                  >({{ obj.basalamPanelName != null ? obj.basalamPanelName.name : "-" }})
                  :</v-card-text
                >
                <v-card-text
                  v-clipboard:copy="obj.basalamVariantId"
                  @click="copied"
                  class="pa-0 text-caption"
                >
                  {{ obj.basalamVariantId }}
                </v-card-text>
              </div>
            </div>
          </v-container>
          <!--portal id-->
          <v-container
            class="pa-0 d-flex align-center gap-1"
            v-if="item.integrator != null && item.integrator.portalId != null"
          >
            <img
              src="@/assets/portal.png"
              style="width: 20px; height: 20px; border-radius: 0"
            />
            <v-card-text class="pa-0 text-caption">{{ $t("id") }}: </v-card-text>
            <v-card-text
              v-if="item.integrator != null && item.integrator.portalId != null"
              v-clipboard:copy="item.integrator.portalId"
              @click="copied"
              class="pa-0 text-caption text-disable secondary--text"
              style="cursor: pointer"
            >
              {{ item.integrator.portalId }}
            </v-card-text>
          </v-container>
          <!--portal variant-->
          <v-container
            class="pa-0 d-flex align-center gap-1"
            v-if="item.integrator != null && item.integrator.portalVariantId != null"
          >
            <img
              src="@/assets/portal.png"
              style="width: 20px; height: 20px; border-radius: 0"
            />
            <v-card-text class="pa-0 text-caption">{{ $t("variable") }}: </v-card-text>
            <v-card-text
              v-if="item.integrator != null && item.integrator.portalVariantId != null"
              v-clipboard:copy="item.integrator.portalVariantId"
              @click="copied"
              class="pa-0 text-caption text-disable secondary--text"
              style="cursor: pointer"
            >
              {{ item.integrator.portalVariantId }}
            </v-card-text>
          </v-container>

          <!--custom filds-->
          <div v-if="item.custom_fields" class="pt-1">
            <v-chip
              v-for="(field, index) in item.custom_fields"
              :key="index"
              label
              color="primary"
              small
              style="margin-left: 1px; margin-right: 1px"
              class="px-1 mb-1"
            >
              <span class="px-1 white--text"> {{ field.key }} : {{ field.value }} </span>
            </v-chip>
          </div>
          <v-card-text class="pa-0 text-caption text-disable secondary--text">
            {{
              item.content
                ? item.content.substr(0, item.deleted_at ? item.content.length : 20)
                : ""
            }}
            {{
              !item.deleted_at && item.content && item.content.length > 20 ? "..." : ""
            }}
          </v-card-text>
        </template>
        <template v-slot:item.tags="{ item }">
          <pl-tags :tags="item.tags || []" />
        </template>
        <template v-slot:item.user.name="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div v-if="item.user" color="primary" dark v-bind="attrs" v-on="on">
                <v-card-text class="pa-0 text-caption">
                  {{ item.user.firstname }} {{ item.user.lastname }}
                </v-card-text>
              </div>
              <v-card-text
                v-else
                class="pa-0 text-caption text-disable secondary--text"
                >{{ $t("haveNot") }}</v-card-text
              >
            </template>
            <span>{{ item.time }}</span>
          </v-tooltip>
        </template>
        <!-- <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template> -->
        <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
          {{ faNum(pageStart) }}–{{ faNum(pageStop) }} {{ $t("of") }} {{ faNum($numberFormat(itemsLength)) }}
        </template>
        <template v-slot:footer.prepend>
          <div class="pl-goto">
            <span>{{ $t("goToPage") }}</span>
            <input v-model.number="page" type="number" min="1" :max="pageCount" class="pl-goto__input pl-num" />
            <span class="pl-num">/ {{ faNum(pageCount) }}</span>
          </div>
        </template>
      </v-data-table>
    <print-studio
      v-model="printStudio"
      :report="plReportKey"
      :title="(titleProp
          ? $t(titleProp)
          : $route.name == 'ProductList'
          ? $t('productList')
          : $route.name == 'VariantsList' || $route.name == 'Variants'
          ? $t('variant-product')
          : $t('serviceList'))"
      :columns="plPrintCols"
      :source="plPrintSource"
      @error="serverErrorHandeler"
    />
  </pro-list-frame>
</template>

<script>
export default {
  name: "ProductListDesktopView",
};
</script>

